var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useEntity } from '../hooks/use-entity';
import { MarkdownContent } from '../elements/markdown-content';
var cls = classNames('content-entity-rich-title');
export var ContentEntityRichTitleDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin: 0;\n    font-weight: 400;\n    b {\n      font-weight: 500;\n    }\n  "], ["\n    margin: 0;\n    font-weight: 400;\n    b {\n      font-weight: 500;\n    }\n  "])))
});
var ContentStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.h1(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Content: styled(MarkdownContent)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles)
};
export var ContentEntityRichTitle = function (props) {
  var className = props.className,
    children = props.children;
  var entity = useEntity(props.entity);
  var title = entity.title,
    titleRich = entity.titleRich,
    name = entity.name;
  var hasTitle = !!((titleRich === null || titleRich === void 0 ? void 0 : titleRich.text) || title || name);
  if (!hasTitle) {
    return null;
  }
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, (titleRich === null || titleRich === void 0 ? void 0 : titleRich.text) ? React.createElement(My.Content, {
    text: titleRich.text
  }) : title || name);
};
ContentEntityRichTitle.defaultProps = ContentEntityRichTitleDefaultProps;
ContentEntityRichTitle.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;